module.exports = __webpack_public_path__ + "static/media/nr.225d3216.svg";